import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PerformanceChart = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('1M');
  
  const periods = [
    { label: '1D', value: '1D' },
    { label: '1W', value: '1W' },
    { label: '1M', value: '1M' },
    { label: '1Y', value: '1Y' }
  ];

  const chartData = [
    { date: '2025-06-11', value: 120500 },
    { date: '2025-06-18', value: 122300 },
    { date: '2025-06-25', value: 121800 },
    { date: '2025-07-02', value: 124200 },
    { date: '2025-07-09', value: 125430 }
  ];

  const formatTooltipValue = (value) => {
    if (value === null || value === undefined) return '₹0';
    return `₹${value.toLocaleString()}`;
  };

  const formatXAxisLabel = (tickItem) => {
    const date = new Date(tickItem);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="card-elevated p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="TrendingUp" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Portfolio Performance</h3>
            <p className="text-sm text-muted-foreground">Track your investment growth</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-1 bg-muted rounded-lg p-1">
          {periods?.map((period) => (
            <Button
              key={period?.value}
              variant={selectedPeriod === period?.value ? "default" : "ghost"}
              size="sm"
              onClick={() => setSelectedPeriod(period?.value)}
              className="px-3 py-1 text-xs"
            >
              {period?.label}
            </Button>
          ))}
        </div>
      </div>

      <div className="h-64 w-full" aria-label="Portfolio Performance Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="date" 
              tickFormatter={formatXAxisLabel}
              stroke="var(--color-muted-foreground)"
              fontSize={12}
            />
            <YAxis 
              tickFormatter={(value) => `₹${((value || 0) / 1000).toFixed(0)}K`}
              stroke="var(--color-muted-foreground)"
              fontSize={12}
            />
            <Tooltip 
              formatter={(value, name) => [formatTooltipValue(value), name]}
              labelFormatter={(label) => `Date: ${new Date(label).toLocaleDateString()}`}
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px',
                color: 'var(--color-foreground)'
              }}
            />
            <Line 
              type="monotone" 
              dataKey="value" 
              stroke="var(--color-primary)" 
              strokeWidth={2}
              dot={{ fill: 'var(--color-primary)', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: 'var(--color-primary)', strokeWidth: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PerformanceChart;